/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseV2,
    PressReleaseV2FromJSON,
    PressReleaseV2FromJSONTyped,
    PressReleaseV2ToJSON,
} from './PressReleaseV2';

/**
 * 
 * @export
 * @interface GetRecommendPressReleasesResponse
 */
export interface GetRecommendPressReleasesResponse {
    /**
     * 
     * @type {number}
     * @memberof GetRecommendPressReleasesResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendPressReleasesResponse
     */
    message: string;
    /**
     * 
     * @type {Array<PressReleaseV2>}
     * @memberof GetRecommendPressReleasesResponse
     */
    data: Array<PressReleaseV2>;
}

export function GetRecommendPressReleasesResponseFromJSON(json: any): GetRecommendPressReleasesResponse {
    return GetRecommendPressReleasesResponseFromJSONTyped(json, false);
}

export function GetRecommendPressReleasesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRecommendPressReleasesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(PressReleaseV2FromJSON)),
    };
}

export function GetRecommendPressReleasesResponseToJSON(value?: GetRecommendPressReleasesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(PressReleaseV2ToJSON)),
    };
}

